/* -----------------UI--------------- */
import type { Distribution } from "@memorang/types";

import type { QuickActionsChipType } from "../../types";
import Box from "../Box";
import DonutChart from "../DonutChart";
import ProductIcon from "../ProductIcon";
import { QuickActionChips } from "../QuickActionChips";
/* -----------------Components--------------- */
import RowStats, { type Stat } from "../RowStats";

/* -----------------Props--------------- */
type Props = {
	distribution: Distribution;
	title: string;
	image?: string;
	stats?: Stat[];
	handleQuickActionPress: (action: QuickActionsChipType["type"]) => void;
	actionChips: QuickActionsChipType[];
};

/* -----------------Component--------------- */
const ContentHero = (props: Props) => {
	const { distribution, stats, image, handleQuickActionPress, actionChips } =
		props;

	const HeroOverallProgressDonutChart = () => {
		return (
			<>
				{image && (
					<DonutChart distribution={distribution} radius={64} innerRadius={50}>
						<ProductIcon image={image} size={64} />
					</DonutChart>
				)}
			</>
		);
	};

	const showStats = stats?.length;

	const Stats = () => <RowStats stats={stats || []} />;

	return (
		<>
			<Box padding={16} gap={16}>
				<HeroOverallProgressDonutChart />
				{showStats ? <Stats /> : null}
			</Box>
			<Box paddingBottom={8}>
				<QuickActionChips
					quickActionsChips={actionChips}
					handleQuickActionPress={handleQuickActionPress}
				/>
			</Box>
		</>
	);
};

export default ContentHero;
